import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;

export const getInstances = () =>  axios.get(`${CoreService.getPrivateURL()}instances/`);
export const getInstance = (instance_id) =>  axios.get(`${CoreService.getPrivateURL()}instances/${instance_id}`);
export const insertInstance = (formData) =>  axios.post(`${CoreService.getPrivateURL()}instances/`,
    formData, {withCredentials:true, headers:{
        'Content-Type':'multipart/form-data'
      }});
export const updateInstance = (instance_id, formData) =>  axios.put(`${CoreService.getPrivateURL()}instances/${instance_id}/`,
    formData, {withCredentials:true, headers:{
        'Content-Type':'multipart/form-data'
      }});
export const removeInstance = (instance_id) =>  axios.delete(`${CoreService.getPrivateURL()}instances/${instance_id}/`, {withCredentials:true});
export const disableInstance = (instance_id) =>  axios.patch(`${CoreService.getPrivateURL()}instances/${instance_id}/`, {withCredentials:true});

const InstancesService = {
  getInstances,
  getInstance,
  insertInstance,
  updateInstance,
  removeInstance,
  disableInstance,
};
export default InstancesService;
